var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: { "has-logo": _vm.showLogo } },
    [
      _c(
        "el-menu",
        { attrs: { "default-active": _vm.activeMenu, "unique-opened": false } },
        _vm._l(_vm.permission_routes, function (route) {
          return _c("sidebar-item", {
            key: route.path,
            attrs: { item: route, "base-path": route.path },
          })
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }